import registerRoutes from './routes';

import defineConstants from './constants';
import defineUserRolesObject from './constants/userRolesObject';
import defineUserInRoleConfig from './constants/userInRole';

import httpInterceptor from './config/httpInterceptor';
import generic from './config/generic';

import currentUserRole from './runtime/currentUserRole';

import authorizationTokenProvider from './services/authorizationToken';
import fileImportTypesService from './services/fileImportTypes';
import vehicleSourcedService from './services/vehicleSourced';
import currentUserService from './services/currentUser';
import topMenuOptionsService from './services/topMenuOptions';
import userRolesService from './services/userRoles';
import mileageSourcedFactory from './services/mileageSourced';
import franchiseFactory from './services/franchises';
import referenceCodeFactory from './services/uniqueReferenceCode';
import lookUpPostCodeFactory from './services/lookUpPostCode';
import enquiryReportTypeService from './services/enquiryReportType';
import securityConfigService from './services/securityConfig';

import spinnerDirective from './directives/spinner';
import tabsDirective from './directives/tabs';
import tabDirective from './directives/tab';
import checkboxDirective from './directives/checkbox';
import onScrollEndDirective from './directives/onScrollEnd';
import radioDirective from './directives/radio';
import accuracyDirective from './directives/accuracy';
import highlightWhenChildOfDirective from './directives/highlightWhenChildOf';
import topMenuDirective from './directives/topMenu';
import postCodeLookUpDirective from './directives/postCodeLookUp';
import displayToDirective from './directives/display-to';

import importExportFilter from './filters/importExport';
import submittedFilter from './filters/submitted';
import booleanFilter from './filters/boolean';

export default function (app) {
    /*   call configs   */
    app.config(httpInterceptor);
    app.config(generic);

    app.run(currentUserRole);

    /*   register services   */
    app.provider('authorizationToken', authorizationTokenProvider);
    app.factory('fileImportTypes', fileImportTypesService);
    app.factory('vehicleSourced', vehicleSourcedService);
    app.factory('currentUser', currentUserService);
    app.factory('topMenuOptions', topMenuOptionsService);
    app.factory('userRoles', userRolesService);
    app.factory('mileageSourced', mileageSourcedFactory);
    app.factory('franchiseList', franchiseFactory);
    app.factory('referenceCodeGenerator', referenceCodeFactory);
    app.factory('lookUpPostCode', lookUpPostCodeFactory);
    app.factory('enquiryReportType', enquiryReportTypeService);
    app.factory('securityConfig', securityConfigService);

    /*   register directive   */
    app.directive('spinner', spinnerDirective);
    app.directive('tabs', tabsDirective);
    app.directive('tab', tabDirective);
    app.directive('checkbox', checkboxDirective);
    app.directive('onScrollEnd', onScrollEndDirective);
    app.directive('radio', radioDirective);
    app.directive('accuracy', accuracyDirective);
    app.directive('highlightWhenChildOf', highlightWhenChildOfDirective);
    app.directive('topMenu', topMenuDirective);
    app.directive('postCodeLookUp', postCodeLookUpDirective);
    app.directive('displayTo', displayToDirective);

    /*   register filters   */
    app.filter('importExport', importExportFilter);
    app.filter('submitted', submittedFilter);
    app.filter('boolean', booleanFilter);

    defineRootState(app);
    defineConstants(app);
    defineUserRolesObject(app);
    defineUserInRoleConfig(app);

    registerRoutes(app);
}

function defineRootState(app) {
    app.config($stateProvider => {
        $stateProvider.state('root', {
            url: '',
            abstract: true,
            template: '<ui-view></ui-view>'
        });
    });
}



// WEBPACK FOOTER //
// ./Client/app/common/index.js